// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoText_root__3KogA"};